import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Nonacbusrentalserviceinpune() {



  const cardData = {
"keyword": "Non AC Bus Rental Service in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Non AC Bus Rental Service in Pune for budget-friendly group travel including school trips, college tours, corporate outings, weddings, pilgrimage journeys, and local transportation needs within Pune and Pimpri-Chinchwad. Our well-maintained non-AC buses with experienced drivers ensure safe, economical, and comfortable group travel for all local routes across Pune and PCMC.",

"topPlaces": [
{
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
}
],



services: [
  {
    name: "Non AC Bus for Hire for Outstation",
    description: "Non AC bus for hire for outstation service provides economical and comfortable transportation for family vacations, pilgrimage journeys, educational tours, tourist travel, and group outings. Spacious seating and smooth highway performance ensure pleasant journeys suitable for long-distance travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "Non AC Tempo Traveller on Rent Pune",
    description: "Non AC Tempo Traveller on rent Pune service offers affordable transportation for educational trips, family outings, local sightseeing, airport transfers, and budget-friendly outstation journeys. Spacious interiors and comfortable seating ensure smooth travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Non AC Bus Hire on Rent in Pune",
    description: "Non AC bus hire on rent in Pune service provides dependable transportation for school trips, office outings, wedding functions, family tours, and local or outstation journeys. Spacious buses ensure comfortable seating and smooth travel experiences suitable for budget-conscious group travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "Non AC Mini Bus Hire on Rent in Pune",
    description: "Non AC mini bus hire on rent in Pune service offers economical transportation for educational tours, family functions, picnic trips, airport transfers, and local group travel requirements. Spacious interiors ensure comfortable seating suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, schools, railway stations, and airports across Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Non AC Bus Hire for Picnic in Pune",
    description: "Non AC bus hire for picnic in Pune service provides comfortable transportation for school outings, family gatherings, office trips, one-day tours, and sightseeing travel. Spacious seating and smooth travel performance ensure pleasant journeys suitable for all age groups and group passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, schools, colleges, offices, and residential areas across Pune. Flexible booking options allow convenient picnic bus reservations."
  },
  {
    name: "Best Bus Rental Service in Pune",
    description: "Best bus rental service in Pune offers reliable transportation for weddings, corporate travel, educational tours, airport transfers, sightseeing journeys, and outstation trips. Spacious buses and professional service ensure comfortable travel experiences suitable for all passenger groups and travel requirements. Experienced chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient bus rental reservations."
  },
  {
    name: "32 35 40 45 Seater Local and Outstation Bus",
    description: "32 35 40 45 seater local and outstation bus service provides spacious transportation for family tours, corporate events, school trips, weddings, pilgrimage journeys, and long-distance travel. Comfortable seating and luggage space ensure smooth highway journeys suitable for large passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, schools, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient large bus reservations."
  },
  {
    name: "14 17 20 25 Seater Bus on Rent Pune",
    description: "14 17 20 25 seater bus on rent Pune service offers multiple seating options for family outings, educational tours, airport transfers, business travel, and outstation journeys. Spacious buses ensure comfortable seating and smooth travel experiences suitable for small and medium-sized groups. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient seater bus reservations."
  },
  {
    name: "Best Tours and Travel Company in Pune",
    description: "Best tours and travel company in Pune provides reliable transportation and travel solutions for family vacations, pilgrimage journeys, sightseeing tours, corporate travel, and group outings. Comfortable vehicles and professional travel services ensure smooth and memorable travel experiences for passengers. Experienced chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient travel reservations."
  },
  {
    name: "Non AC Bus for Wedding in Pune",
    description: "Non AC bus for wedding in Pune service offers economical transportation for wedding guests, family members, bridal parties, and marriage event travel requirements. Spacious seating ensures comfortable journeys suitable for wedding ceremonies and family celebrations. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Non AC Bus for Corporate Trip in Pune",
    description: "Non AC bus for corporate trip in Pune service provides affordable transportation for employee travel, office outings, industrial visits, conferences, and company group journeys. Spacious interiors ensure comfortable seating suitable for business passengers and executive teams. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, and commercial locations across Pune. Flexible booking options allow convenient corporate trip bus reservations."
  },
  {
    name: "Non AC Bus for School Picnic in Pune",
    description: "Non AC bus for school picnic in Pune service offers safe and economical transportation for educational tours, school outings, student travel, and picnic journeys. Spacious buses ensure comfortable seating suitable for students, teachers, and educational groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school picnic bus reservations."
  },
  {
    name: "Non AC Bus for Family Trip in Pune",
    description: "Non AC bus for family trip in Pune service provides comfortable transportation for holiday vacations, pilgrimage tours, sightseeing journeys, and group travel with relatives and family members. Spacious seating and luggage space ensure smooth travel experiences suitable for local and outstation family trips. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip bus reservations."
  },
  {
    name: "Non AC Bus for Airport Transfer Pune",
    description: "Non AC bus for airport transfer Pune service offers dependable transportation for tourist groups, wedding guests, office teams, and family passengers traveling to and from airport terminals. Spacious buses ensure comfortable luggage handling and smooth airport journeys suitable for large passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport bus reservations."
  },
  {
    name: "Affordable Mini Bus on Rent in Pune",
    description: "Affordable mini bus on rent in Pune service provides economical transportation for family outings, educational tours, airport transfers, local sightseeing, and outstation journeys. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for small and medium-sized passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, schools, railway stations, and airports across Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Non AC Bus Rental Service Pune",
    description: "Non AC bus rental service Pune offers reliable and affordable transportation for weddings, office outings, school trips, pilgrimage travel, and sightseeing journeys. Spacious buses ensure comfortable seating and smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, schools, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC bus reservations."
  }
],

tableData: [
  ["Non AC Bus for Hire for Outstation", "Non AC Tempo Traveller on Rent Pune"],
  ["Non AC Bus Hire on Rent in Pune", "Non AC Mini Bus Hire on Rent in Pune"],
  ["Non AC Bus Hire for Picnic in Pune", "Best Bus Rental Service in Pune"],
  ["32 35 40 45 Seater Local and Outstation Bus", "14 17 20 25 Seater Bus on Rent Pune"],
  ["Best Tours and Travel Company in Pune", "Non AC Bus for Wedding in Pune"],
  ["Non AC Bus for Corporate Trip in Pune", "Non AC Bus for School Picnic in Pune"],
  ["Non AC Bus for Family Trip in Pune", "Non AC Bus for Airport Transfer Pune"],
  ["Affordable Mini Bus on Rent in Pune", "Non AC Bus Rental Service Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Non AC Bus Rental Service in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable non AC bus rental service in Pune with comfortable seating, professional drivers, and smooth travel arrangements for group tours, school trips, and corporate travel."
      },
      {
        WhyChooseheading: "Affordable Non AC Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable non AC bus rental packages in Pune with transparent pricing, budget-friendly travel options, and complete booking support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Non AC Bus Booking Service",
        WhyChoosedescription: "Our non AC bus rental service in Pune operates 24 hours for school tours, wedding transportation, employee travel, picnic trips, pilgrimage journeys, and outstation group travel."
      },
      {
        WhyChooseheading: "Comfortable & Spacious Non AC Buses",
        WhyChoosedescription: "All non AC buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and designed to provide safe and comfortable travel experiences for large groups."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Travel Plans",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day outstation journeys, and flexible travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from different seating capacity non AC buses suitable for school groups, wedding guests, office teams, tourists, and family travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, schools, offices, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, Pimpri, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is non AC bus rental service in Pune?", answer: "Non AC bus rental service in Pune provides budget-friendly group transportation for school trips, corporate travel, family tours, weddings, and outstation journeys." },
    { question: "Is non AC bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 non AC bus rental service in Pune." },
    { question: "Which seating capacity non AC buses are available?", answer: "Aaradhya Travels offers non AC buses with multiple seating capacities suitable for small and large group travel." },
    { question: "Can I book non AC buses for outstation travel?", answer: "Yes, customers can book non AC buses for outstation tours, pilgrimage journeys, school trips, and holiday travel." },
    { question: "Do you provide non AC buses for school and corporate trips?", answer: "Yes, Aaradhya Travels provides non AC bus rental service for school tours, office outings, conferences, and employee transportation." },
    { question: "Are all non AC buses maintained properly?", answer: "Yes, all non AC buses are regularly cleaned and maintained for safe and comfortable group travel." },
    { question: "Can I book non AC bus rental service online in Pune?", answer: "Yes, customers can easily book non AC bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family functions?", answer: "Yes, Aaradhya Travels provides spacious non AC buses suitable for weddings, family tours, and group events." },
    { question: "Are non AC bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for non AC bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Ganesh Bhosale",
    feedback:
      "Traveling with a large group became affordable and well-managed thanks to the non AC bus rental service in Pune by Aaradhya Travels. The vehicle was clean, and the journey was handled smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kalyani Deshmukh",
    feedback:
      "Aaradhya Travels arranged a non AC bus rental service in Pune for our community trip, and the experience was very organized. Everyone traveled together comfortably, and the service was reliable.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Non AC Bus Rental Service in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/non-ac-bus-rental-service-pune.jpg",
  "description": "Book Non AC Bus Rental Service in Pune with Aaradhya Travels for weddings, corporate trips, school picnics, family tours, airport transfers, and outstation travel. Available in 14, 17, 20, 25, 32, 35, 40, and 45 seater options across Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2314"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/non-ac-bus-rental-service-in-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Non AC Bus Rental Service in Pune | Affordable Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Non AC Bus Rental Service in Pune with Aaradhya Travels. Affordable non AC buses available for weddings, corporate trips, family tours, school picnics, airport transfers, and outstation travel in 14 to 45 seater options."
  />

  <meta
    name="keywords"
    content="Non Ac bus for hire for outstation, Non ac tempo traveller on rent Pune, Non Ac bus hire on rent in Pune, Non ac mini bus hire on rent in Pune, Non ac bus hire for picnic in Pune, Best bus rental service in Pune, 32 35 40 45 seater local and outstation bus, 14 17 20 25 seater bus on rent Pune, Best tours and travel company in Pune, Non AC bus for wedding in Pune, Non AC bus for corporate trip in Pune, Non AC bus for school picnic in Pune, Non AC bus for family trip in Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Nonacbusrentalserviceinpune;